import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setDesignStep, setScaleSetState, showRoomNamePopup, showRoomSeperatorPopup } from '../../Actions/ApplicationStateAction';
import { Typography } from '../../design_system/StyledComponents/components/Typography';
import image from "../../assets/roomSeperator.svg"
import divide from "../../assets/WallOpening.png"
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Button } from '../../design_system/StyledComponents/components/Button';
import { useActions } from '../../hooks/useActions';
import "./RoomSeperatorPopup.css"
import { Close } from '@mui/icons-material';
import useModes from '../../hooks/useModes';
import { setShowFirstTimePopup } from '../../Actions/PopupAction';
import { setContextualMenuStatus, setShowPopup, setTypeId } from '../../Actions/DrawingActions';


const MySwal = withReactContent(Swal);


const RoomSeperatorPopup = () => {
    const { roomSeperatorPopup, img } = useSelector((state) => state.ApplicationState);
    const { handleSaveClick } = useActions();
    const dispatch = useDispatch();
    const { perpendicularHandler, toggleSelectionMode } = useModes();

    const handleClose = () => {
        dispatch(showRoomSeperatorPopup(false));
    }

    const handleSave = () => {
        handleSaveClick();
        handleClose();

        if (img){
            dispatch(setScaleSetState(true));  // Enable scale setting mode
  
            toggleSelectionMode()
            dispatch(setShowFirstTimePopup({
              showFirstTimePopup: true,
              firstTimePopupNumber: 14,
              firstTimePopupType: "ui",
              popupDismissable: true,
            }))
        } else {
            dispatch(setTypeId(0));
            dispatch(setDesignStep(3));
            dispatch(showRoomNamePopup(true));
            dispatch(setShowPopup(false));
            dispatch(setContextualMenuStatus(false));
            dispatch(setScaleSetState(false));
        }

    }

    return (
        roomSeperatorPopup &&
        <div className='room-seperator-popup'>
            <div style={{boxShadow:"none"}} className="help-popup-close-icon" onClick={handleSave}>
                <Close />
            </div>
            <div className='room-seperator-popup-header'>
                <Typography modifiers={["medium", "header5"]}>Draw room separators</Typography>
                <div className='room-seperator-popup-header-icon'>
                    <img src={divide} alt="" style={{ width: "24px", height: "24px", }} />
                    <Typography>Room separator</Typography>
                </div>
            </div>
            <Typography modifiers={["subtitle1"]} className='room-seperator-subhead'>To give each room its own identity</Typography>
            <img className='room-seperator-img' src={image} alt="roomSeperator" />
            <Typography modifiers={["body", "medium"]} className='room-seperator-confirm'>Have you split a large multi-room areas into individual rooms?</Typography>
            <div className='room-seperator-footer'>
                <Button onClick={handleClose} modifiers={["black"]}>No, I will add now</Button>
                <Button onClick={handleSave} modifiers={["blackOutline"]}>Yes, let’s proceed</Button>
            </div>
        </div>
    )
}

export default RoomSeperatorPopup
